export   const calculatePlatformFee = (ticketPrice) => {
	let baseFee;
	let percentage;
	let maxCap = null;

	if (ticketPrice <= 500) {
		baseFee = 20;
		percentage = 0.06;
	} else if (ticketPrice <= 1500) {
		baseFee = 30;
		percentage = 0.07;
	} else if (ticketPrice <= 3000) {
		baseFee = 40;
		percentage = 0.06;
	} else {
		baseFee = 60;
		percentage = 0.04;
		maxCap = 300;
	}

	let fee = baseFee + ticketPrice * percentage;

	// Apply max cap if applicable
	if (maxCap !== null && fee > maxCap) {
		fee = maxCap;
	}

	return Math.round(fee * 100) / 100; // Round to 2 decimal places
};